import { FakeDoorType } from './types'

const VALID_TYPES = new Set(Object.values(FakeDoorType).map((v) => v.toLowerCase()))

export const resolveFakeDoorType = (rawType: string | null): FakeDoorType => {
  const normalized = rawType?.trim().toLowerCase() ?? ''

  if (!normalized || !VALID_TYPES.has(normalized)) {
    return FakeDoorType.UNSUPPORTED
  }

  return normalized.toUpperCase() as FakeDoorType
}
